import { BRAND } from '../config/brand';
export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-navy flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-xl p-8 w-full max-w-md">
        <img src={BRAND.logo.lockup} alt={BRAND.name} className="h-10 w-auto mx-auto mb-5" />
        <h1 className="text-[28px] leading-tight font-extrabold tracking-tight text-center text-ink">{title}</h1>
        {subtitle && <p className="text-center text-ink-muted mt-1 mb-6">{subtitle}</p>}
        {!subtitle && <div className="mb-6" />}
        {children}
      </div>
    </div>
  );
}

export const inputClass =
  'w-full h-11 px-3 border border-line-strong rounded-lg text-[15px] text-ink bg-white focus:outline-none focus:ring-2 focus:ring-blue focus:border-blue disabled:bg-surface disabled:border-line disabled:text-ink-muted';
export const primaryButton =
  'w-full h-11 bg-blue text-white px-4 rounded-xl hover:bg-blue-dark transition disabled:opacity-50 font-semibold';
export const secondaryButton =
  'inline-flex items-center justify-center h-11 px-4 rounded-xl border border-line-strong bg-white text-ink font-semibold hover:bg-surface transition disabled:opacity-50';
export const errorBox = 'bg-coral-soft border border-coral/40 text-coral-ink px-4 py-3 rounded-lg text-sm';
export const noticeBox = 'bg-blue-soft border border-blue/30 text-ink px-4 py-3 rounded-lg text-sm';
